import React from 'react';
import { Route, Switch, RouteChildrenProps } from 'react-router-dom';
import constants from 'utils/constants';
import { ActionName } from 'components/wires/WireContext';

const Wire = React.lazy(() => import(/* webpackChunkName: 'Wire' */ 'components/wires'));

const WIRE_PATH = `${constants.WORKSPACES.PYMTCNTR}/wires`;

const WireRoutes: React.FC = () => (
  <Switch>
    <Route
      path={`${WIRE_PATH}/create/:paymentType`}
      component={() => <Wire action={ActionName.CREATE} />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/initiate/:templateCode`}
      component={() => <Wire action={ActionName.INITIATE} />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template/:paymentType`}
      component={() => <Wire action={ActionName.TEMPLATE} />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template-payment-copy/:bankTrace`}
      component={() => <Wire action={ActionName.TEMPLATE_COPY_PAYMENT} />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template-view/:templateCode`}
      component={() => <Wire action={ActionName.TEMPLATE_VIEW} />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template-modify/:templateCode`}
      component={() => <Wire action={ActionName.TEMPLATE_MODIFY} />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/:action/:bankTrace`}
      render={(router: RouteChildrenProps<{ action: string; bankTrace: string }>) => (
        // TODO: Add another default action to handle when URL action is not known
        <Wire action={(router?.match?.params?.action as ActionName) ?? ActionName.CREATE} />
      )}
      exact
    />
    {/*
    <Route
      path={`${WIRE_PATH}/template-copy/:templateCode`}
      component={() => <Wire action="template-copy" />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template-modify/:templateCode`}
      component={() => <Wire action="template-modify" />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template-import-review/:pendingNumber/:batchSequence`}
      component={() => <ImportReview action="template-import-review" />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/template/:paymentType`}
      component={() => <Wire action="template" />}
      exact
    />
    <Route
      path={`${WIRE_PATH}/import-review/:pendingNumber/:batchSequence`}
      component={() => <ImportReview action="import-review" />}
      exact
    />
     */}
    {/* TODO: Can be a specific missing route for Wire */}
    {/* <Route component={() => <h1>Can be a specific to payment center missing routes</h1>} /> */}
  </Switch>
);

export default WireRoutes;
